import { isVimeoVideoURL } from "./isVimeoVideoURL"
import { isYouTubeURL } from "./isYouTubeURL"

export const isVideoURL = (value: string) => {
  return isVimeoVideoURL(value) || isYouTubeURL(value)
}
